
import { VContainer } from "vuetify/lib";

export default VContainer.extend({});
